import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex gap-2" }
const _hoisted_2 = { class: "flex flex-col gap-1.5" }
const _hoisted_3 = { class: "flex items-baseline gap-2 pt-1" }
const _hoisted_4 = { class: "text-xs font-bold" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "text-muted-foreground text-[10px]" }
const _hoisted_7 = { class: "text-xs leading-4" }

import type { Comment } from '@/types';
    import EmployeeAvatar from '@/components/EmployeeAvatar.vue';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CommentsMessage',
  props: {
    comment: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const name = computed(() => {
        if (props.comment.author_is_user) {
            return t('translations.you');
        }

        return props.comment.user?.name ?? t('translations.deleted');
    });

    const email = computed(() => {
        return props.comment.user?.email ?? null;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EmployeeAvatar, {
      user: _ctx.comment.user,
      class: "size-6 border-none shadow-sm"
    }, null, 8, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(name.value), 1),
        (email.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `mailto:${email.value}`,
              class: "text-secondary text-xs leading-none hover:underline"
            }, _toDisplayString(email.value), 9, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.comment.last_created_at), 1)
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.comment.body), 1)
    ])
  ]))
}
}

})